import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { AppConfig } from "../../app-config";
import { tap } from "rxjs/operators";
import { TokenStorageService } from "../auth/token-storage.service";

const httpOptions = {
    headers: new HttpHeaders({ "Content-Type": "application/json" }),
    observe: "response" as "body",
};

@Injectable({
    providedIn: "root",
})
export class SujetoObligadoService {
    constructor(
        private http: HttpClient,
        private tokenStorage: TokenStorageService,
        private appConfig: AppConfig
    ) {
        this.API_URL = appConfig.api_url;
    }
    API_URL = "";

    getAll(page, pageSize): Observable<any> {
        return this.http
            .post(
                this.API_URL + "sujeto-obligado/all",
                { tipos: [], pagina: page, cantidad: pageSize },
                httpOptions
            )
            .pipe(
                tap((objetivos) => {
                    return objetivos;
                })
            );
    }

    get(soId): Observable<any> {
        return this.http.get(
            this.API_URL + "sujeto-obligado/" + soId,
            httpOptions
        );
    }

    getByRepresentante(): Observable<any> {
        return this.http.get(
            this.API_URL + "sujeto-obligado/acceso/externo",
            httpOptions
        );
    }

    count(): Observable<any> {
        return this.http.post(
            this.API_URL + "sujeto-obligado/count",
            { tipos: [] },
            httpOptions
        );
    }

    register(objetivo): Observable<any> {
        return this.http.post(
            this.API_URL + "sujeto-obligado/add",
            objetivo,
            httpOptions
        );
    }

    addRepresentante(id, representante): Observable<any> {
        return this.http.post(
            this.API_URL + `sujeto-obligado/${id}/representante/add`,
            representante,
            httpOptions
        );
    }

    delete(id): Observable<any> {
        return this.http.delete(
            this.API_URL + "sujeto-obligado/" + id,
            httpOptions
        );
    }

    deleteRepresentante(id, idRepresentante): Observable<any> {
        return this.http.delete(
            this.API_URL +
                `sujeto-obligado/${id}/representante/${idRepresentante}`,
            httpOptions
        );
    }

    edit(id, objetivo): Observable<any> {
        return this.http.put(
            this.API_URL + "sujeto-obligado/" + id,
            objetivo,
            httpOptions
        );
    }
}
